import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import TrackingInformation from '../components/tracking-information';
import ShipFrom from '../components/ship-from';
import Weight from '../components/weight';
import SelectedService from '../components/selected-service';
import Package from '../components/package';
import Confirmation from '../components/confirmation';
import Rate from '../components/rate';
import TotalCost from '../components/total-cost';
import RequestedService from '../components/requested-service';
import ProviderStatus from '../components/provider-status';
import PickupDate from '../components/pickup-date';
import DeliveryDate from '../components/delivery-date';
import DriverTip from '../components/driver-tip';
import { messages } from '../../../fulfillment-planner/labeled-row/messages';
import Global from '../../../store/global-selectors';
import style from '../components/style.module.css';

import { getCarrierDisplayName } from '../../../components/data-driven-logo/get-carrier-display-name';
import { getCarrierSupportContact } from '../../../services/local-delivery/carrier-support-contact-service';

const LocalDeliveryRateCard = ({ shipment, packagingDetails }) => {
  const {
    carrierId,
    selectedService,
    trackingInformation,
    totalCost,
    confirmation,
    deliveryDate,
    fulfillmentPlanId,
    shippingCost,
    pickupDate,
    shipDate,
  } = shipment;
  const { shipFrom, packageType, weight } = packagingDetails;

  const { driverTip } =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId,
        property: 'labelConfiguration',
      }),
    ) ?? {};
  const carrierNameDescriptor = getCarrierDisplayName(carrierId);
  const carrierName = carrierNameDescriptor.values?.name || '';
  const { phone, email } = getCarrierSupportContact(carrierId);

  return (
    <>
      <RequestedService />
      <TrackingInformation isLocalDelivery showMdash={!trackingInformation} trackingInformation={trackingInformation} />
      <ProviderStatus />
      <SelectedService selectedService={selectedService} showMdash={!selectedService} />
      <ShipFrom shipFrom={shipFrom} />
      <PickupDate pickupDate={pickupDate || shipDate} />
      <DeliveryDate deliveryDate={deliveryDate} />
      <Weight showMdash={!weight} weight={weight} />
      <Package packageType={packageType} showMdash={!packageType} />
      <Confirmation confirmation={confirmation} showMdash={!confirmation} />
      <DriverTip driverTip={driverTip} />
      <Rate rate={shippingCost} />
      <TotalCost asStandardRow totalCost={totalCost} />
      {!!trackingInformation && (
        <div className={style['helper-text']}>
          <FormattedMessage
            {...messages.manageDeliveryChangesText}
            values={{
              carrierName,
              phone: phone ? (
                <Button href={`tel:${phone}`} theme='link'>
                  {phone}
                </Button>
              ) : (
                ''
              ),
              email: email ? (
                <Button href={`mailto:${email}`} theme='link'>
                  {email}
                </Button>
              ) : (
                ''
              ),
            }}
          />
        </div>
      )}
    </>
  );
};

LocalDeliveryRateCard.propTypes = {
  shipment: PropTypes.object.isRequired,
  packagingDetails: PropTypes.object.isRequired,
};

export default LocalDeliveryRateCard;
